import React from "react";
import { Link } from "react-router";

export default function AccessDenied() {
  return (
    <div className="container text-center">
      <h1 className="mt-5">Acceso Denegado</h1>
      <p>No tienes permiso para acceder a esta página.</p>
      <Link to="/" className="btn btn-primary mt-3">
        Volver al Inicio
      </Link>
    </div>
  );
}
